
import instance from "./instance";
const responseData = response => response.data;

export function getCurrentGlobalSettings() {
    return instance.request({ url: "/cms/marketing/global-settings", method: "GET" }).then(responseData);
}

export function updateGlobalSettings(settings) {
    return instance.request({ url: "/cms/marketing/global-settings", method: "POST", data: settings }).then(responseData);
}